

module.exports = __webpack_require__.stylable.create(
    "horizontalmenusubmenu2686754227",
    {"classes":{"root":"horizontalmenusubmenu2686754227__root","listWrapper":"horizontalmenusubmenu2686754227__listWrapper","pageWrapper":"horizontalmenusubmenu2686754227__pageWrapper","pageStretchWrapper":"horizontalmenusubmenu2686754227__pageStretchWrapper","category":"horizontalmenusubmenu2686754227__category","columnsList":"horizontalmenusubmenu2686754227__columnsList","flex":"horizontalmenusubmenu2686754227__flex","listItem":"horizontalmenusubmenu2686754227__listItem","rowItem":"horizontalmenusubmenu2686754227__rowItem","heading":"horizontalmenusubmenu2686754227__heading","menuItem":"horizontalmenusubmenu2686754227__menuItem"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    35,
    null
);
